import { Link } from "react-router-dom";
import { ShieldCheck, Lock, Download } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="relative border-t border-slate-400/10 bg-panel overflow-hidden">
      <div className="pointer-events-none select-none absolute -bottom-8 left-0 right-0 text-center">
        <span className="stroke-watermark font-display font-black uppercase text-[13vw] leading-none whitespace-nowrap">
          Keep the wrenches turning
        </span>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-40">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div data-testid="footer-brand"><Logo /></div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
              Battle-tested administrative systems for high-output auto shops. Written by people who
              have actually run bays — not a software company renting you back your own paperwork.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <span data-testid="footer-square-badge" className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-300 border border-slate-400/20 px-3 py-1.5">
                <Lock className="w-3 h-3 text-blaze" /> Square Secure Checkout
              </span>
              <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-300 border border-slate-400/20 px-3 py-1.5">
                <ShieldCheck className="w-3 h-3 text-blaze" /> 256-bit SSL
              </span>
              <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-300 border border-slate-400/20 px-3 py-1.5">
                <Download className="w-3 h-3 text-blaze" /> Instant Delivery
              </span>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono text-[10px] uppercase tracking-[0.25em] text-blaze mb-4">Kits</h4>
            <ul className="space-y-2.5 text-sm text-slate-400">
              <li><Link to="/free" className="text-blaze hover:text-orange-300 transition-colors">Free Sample — $0</Link></li>
              <li><Link to="/" className="hover:text-blaze transition-colors">Starter — $67</Link></li>
              <li><Link to="/" className="hover:text-blaze transition-colors">Shop Builder — $147</Link></li>
              <li><Link to="/" className="hover:text-blaze transition-colors">Complete — $297</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono text-[10px] uppercase tracking-[0.25em] text-blaze mb-4">Legal</h4>
            <ul className="space-y-2.5 text-sm text-slate-400">
              <li><Link to="/terms" data-testid="legal-terms-trigger" className="hover:text-blaze transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" data-testid="legal-privacy-trigger" className="hover:text-blaze transition-colors">Privacy Policy</Link></li>
              <li><Link to="/refund-policy" data-testid="legal-refund-trigger" className="hover:text-blaze transition-colors">Digital Refund Policy</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono text-[10px] uppercase tracking-[0.25em] text-blaze mb-4">Support</h4>
            <ul className="space-y-2.5 text-sm text-slate-400">
              <li><Link to="/contact" className="hover:text-blaze transition-colors">Contact the Shop Desk</Link></li>
              <li><a href="mailto:support@mechanicstoolkit.com" className="hover:text-blaze transition-colors">support@mechanicstoolkit.com</a></li>
              <li><Link to="/admin" className="hover:text-blaze transition-colors">Shop Owner Login</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-slate-400/10 flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            © 2026 The Mechanic's Tool Kit. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            Templates are educational — have local counsel review.
          </p>
        </div>
      </div>
    </footer>
  );
}
